<template>

</template>

<script>
export default {
  name: "Scoreboard.vue"
}
</script>

<style scoped>

</style>